import { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { CSSTransition } from "react-transition-group";

import PortfolioCard from "./PortfolioCard";

import { filterKey, projectData } from "../data/portfolioData";

export default function Portfolio() {
  const [filter, setFilter] = useState("*");
  const [filterData, setFilterData] = useState(projectData);
  const [loading, setLoading] = useState(false);

  const handleFilterFunc = async (key: string) => {
    try {
      setLoading(true);
      setFilter(key);
      setFilterData([]);

      await new Promise((resolve) => setTimeout(resolve, 800));

      const filteredData =
        key === "*"
          ? projectData
          : projectData.filter((item) => item.type.includes(key));
      setFilterData(filteredData);
    } catch (error) {
      // Handle any errors that may occur
      console.error("An error occurred while filtering data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-start justify-center w-full h-full overflow-x-hidden overflow-y-auto bg-gradient-to-br from-dark-bg-950 via-dark-bg-900 to-dark-bg-950 dark:bg-hero-pattern px-3 transition-all duration-300">
      <div className="max-w-[880px] md:min-w-[700px] lg:min-w-[880px] flex items-center justify-center flex-col gap-7 mb-[170px] mt-[90px]">
        <Fade delay={1000} triggerOnce={true}>
          <h1 className="uppercase md:text-[2.5em] text-[2em] text-center font-bold text-white font-inter tracking-wide">
            <span className="bg-gradient-to-r from-accent-400 via-purple-accent-400 to-accent-500 bg-clip-text text-transparent">
              My Recent Works
            </span>
          </h1>
        </Fade>
        <Fade delay={1000} triggerOnce={true}>
          <p className="text-gray-300 text-lg text-center font-inter">
            Check out my latest <span className="text-accent-400 font-semibold">web</span> & <span className="text-purple-accent-400 font-semibold">blockchain</span> development portfolio projects.
          </p>
        </Fade>
        <Fade delay={1300} triggerOnce={true} className="w-full">
          <div className="grid items-center justify-center w-full grid-cols-3 gap-4 md:grid-cols-3 lg:grid-cols-6">
            {filterKey.map((data, key) => (
              <div
                key={key}
                className={`flex items-center justify-center rounded-xl px-4 py-3 w-full font-medium border border-white/20
                  uppercase bg-dark-bg-800/50 md:text-[.7em] text-[.65em] cursor-pointer hover:bg-gradient-to-r hover:from-accent-600/20 hover:to-purple-accent-600/20 duration-300 transition-all text-center backdrop-blur-sm
            ${
              filter === data.key
                ? `bg-gradient-to-r from-accent-600 to-purple-accent-600 text-white shadow-glow`
                : "text-gray-400 hover:text-white"
            }`}
                onClick={() => handleFilterFunc(data.key)}
              >
                <span>{data.title}</span>
              </div>
            ))}
          </div>
          {filter === "*" ? (
            <small className="text-gray-400 text-sm uppercase font-inter">
              showing all projects.
            </small>
          ) : (
            <small className="text-gray-400 text-sm uppercase font-inter">
              {" "}
              showing{"  "}
              <span className="text-xl text-accent-400 font-bold">
                {filterData.length}
              </span>
              {"  "}
              projects filter by <span className="text-purple-accent-400 font-semibold">{filter}</span>.{" "}
            </small>
          )}
        </Fade>
        <Fade delay={1600} className="w-full">
          <div className="grid w-full gap-10 md:grid-cols-2">
            {filterData.map((data, index) => (
              <CSSTransition timeout={3000} classNames="fade" key={index}>
                <PortfolioCard
                  key={index}
                  role={data.role}
                  summary={data.summary}
                  imgUrl={data.imgUrl}
                  siteUrl={data.siteUrl || ""}
                  skills={data.skills}
                />
              </CSSTransition>
            ))}
          </div>
        </Fade>
      </div>
      <div
        id="data"
        className={`absolute bg-gradient-to-br from-accent-600/20 to-purple-accent-600/20 backdrop-blur-sm transition-all duration-300 top-0 flex items-center justify-center ${
          loading ? "w-full h-1/2 opacity-100" : "h-0 opacity-0"
        }`}
      ></div>
      <div
        id="data"
        className={`absolute bg-gradient-to-tr from-purple-accent-600/20 to-accent-600/20 backdrop-blur-sm transition-all duration-300 bottom-0 flex items-center justify-center ${
          loading ? "w-full h-1/2 opacity-100" : "h-0 opacity-0"
        }`}
      ></div>
    </div>
  );
}
